<div style="width: 100%;">
  <mat-card class="box">
      <div class="divtitle">
        <span class="flex-container" style="padding: 8px;">
          <h1 class="label">{{'devices.label' | transloco}}</h1>
          <div *ngIf="storageService.roleId==1">
            <button mat-raised-button color="primary" routerLink="/device">{{'devices.new' | transloco}}</button>
            <button mat-raised-button color="primary" (click)="scanQr()"><mat-icon>qr_code_scanner</mat-icon></button>
          </div>
        </span>
      </div>
  </mat-card>
</div>

<div style="width: 100%;">
  <mat-card class="box">
    <div>
      <div class="formBox">
        <form method="post" class="wrapper" >
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="id">
            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >ID.</th>
              <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <!-- serial_number Column -->
            <ng-container matColumnDef="serial_number">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.sn' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.serial_number}} </td>
            </ng-container>

            <!-- assigned Column -->
            <!-- <ng-container matColumnDef="assigned">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.asigned' | transloco}}</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [disabled]="true" checked="{{element.assigned}}"></mat-checkbox>
              </td>
            </ng-container> -->

            <!-- registered Column -->
            <!-- <ng-container matColumnDef="registered">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.registered' | transloco}}</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [disabled]="true" checked="{{element.registered}}"></mat-checkbox>
              </td>
            </ng-container> -->

            <!-- company_id Column -->
            <ng-container matColumnDef="company_id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.company' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.company_id}} </td>
            </ng-container>

            <!-- project_name Column -->
            <ng-container matColumnDef="project_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.project' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.project_name}} </td>
            </ng-container>

            <!-- zone_name Column -->
            <ng-container matColumnDef="zone_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.zone' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.zone_name}} </td>
            </ng-container>

            <!-- user_name Column -->
            <ng-container matColumnDef="user_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.user' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.user_name}} </td>
            </ng-container>

            <!-- current_device_state Column -->
            <ng-container matColumnDef="current_device_state">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.current_device_state' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.current_device_state | deviceStatus}} </td>
            </ng-container>

            <!-- current_firmware_name Column -->
            <ng-container matColumnDef="current_firmware_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'devices.current_firmware_name' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element.current_firmware_name}} </td>
            </ng-container>

            <!-- <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Accion</th>
              <td mat-cell *matCellDef="let element">
                  <button (click)="anadir(element)">Activar</button>
              </td>
            </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let j =index;"
            (click)="onRowClicked(row); $event.stopPropagation()" tabindex="0" (keydown.enter)="onRowClicked(row)"
            [ngClass]="{'row1':j%2 === 0 , 'row2':j%2 != 0 }"> </tr>

          </table>

          <div class="divPag">
            <mat-paginator [pageSizeOptions]="[9, 10, 20, 50]"
                            showFirstLastButtons
                            aria-label="Select page">
            </mat-paginator>
          </div>
        </form>
      </div>

  </div>
  </mat-card>
</div>

<div>
  <mat-card *ngIf="isLoading" class="center-loading">
    <mat-card-content style="margin: 20%;" >
      <mat-progress-spinner style="margin: 0 auto;" color="primary" mode='indeterminate'value='50'></mat-progress-spinner>
    </mat-card-content>
  </mat-card>
</div>
